import "../scss/page.scss";

import "../scss/about.scss";

import "./scripts/about/base.js";